import { Link } from "react-router-dom";
import { Lock, ArrowRight } from "lucide-react";
import { useBranding } from "@/contexts/BrandingContext";

/**
 * Shown on club public pages when the club's plan does not include the website
 * (website is a Pro-plan feature). The management panel stays fully available.
 */
export const SiteDisabled = () => {
    const { branding } = useBranding();
    return (
        <div className="min-h-screen bg-liv-black text-white flex items-center justify-center px-6" data-testid="site-disabled">
            <div className="max-w-xl w-full border border-liv-border bg-liv-card p-8 md:p-12">
                <div className="w-12 h-12 border border-liv-yellow/50 flex items-center justify-center mb-6">
                    <Lock className="w-5 h-5 text-liv-yellow" />
                </div>
                <div className="overline text-liv-yellow">{branding?.name || "Kulüp"}</div>
                <h1 className="font-display text-4xl md:text-5xl uppercase mt-2 leading-none">Web sitesi yayında değil</h1>
                <p className="text-neutral-400 mt-5 text-sm md:text-base leading-relaxed">
                    Kulüp web sitesi <b className="text-white">Pro pakete</b> dahildir. Mevcut paketinizde kulübünüzü yönetim panelinden
                    yönetebilirsiniz; web sitesini açmak için paketinizi Pro'ya yükseltmeniz yeterli.
                </p>
                <div className="flex flex-wrap gap-3 mt-8">
                    <Link to="/admin" className="btn-primary inline-flex items-center gap-2" data-testid="site-disabled-panel-btn">
                        Yönetim Paneline Git <ArrowRight className="w-4 h-4" />
                    </Link>
                    <Link to="/admin/paketim" className="btn-secondary inline-flex items-center gap-2" data-testid="site-disabled-upgrade-btn">
                        Paketi Yükselt
                    </Link>
                </div>
            </div>
        </div>
    );
};

/** True when the current club may not publish a public website. */
export const useSiteEnabled = () => {
    const { branding, loaded } = useBranding();
    if (!loaded) return null;
    if (branding?.is_platform) return true;
    return branding?.site_enabled !== false;
};
